<template lang="pug">
b-modal(
  id="modal-user_info_add"
  hide-header-close
  no-close-on-esc
  no-close-on-backdrop
  :title="modal_title"
  :size="step === 5 ? 'lg' : 'md'"
  :dialog-class="step === 5 ? 'modal-user-info-add--step5' : ''"
)
  div(v-if="step == 1")
    div.form-group
      label(for='company_name') 会社名
      input.form-control(type='text',
        placeholder='株式会社⚪︎⚪︎⚪︎（個人の場合は「個人」と記入）',
        name='company_name',
        v-model="company_name"
      )
    div.form-group(v-if="!current_user.name || current_user.name == ''")
      label(for='name') 担当者名
      input.form-control(type='text',
        placeholder='例) 田中 太郎',
        name='name',
        v-model="name"
      )
    div.form-group(v-if="!current_user.tel || current_user.tel == ''")
      label(for='tel')  電話番号(ハイフン無し)
      input.form-control(type='text',
        placeholder="08012345678",
        name='tel',
        v-model="tel"
      )
      small.text-danger(v-if="tel != '' && !validateTel()") ※数字のみで指定してください。

    div.form-group
      label(for='tel') WebサイトのURL
      input.form-control(type='text',
        placeholder="https://sample.com",
        name='host',
        v-model="host"
      )
      div
        small.text-danger(v-if="host != '' && !validateHost()") ※正しいURLを指定してください。

    //- div.form-group
    //-   label(for="question2") 導入サポート（無料）
    //-   b-form-radio-group(v-model="is_support_required", name="is_support_required")
    //-     b-form-radio(:value="1") 希望する
    //-     b-form-radio(:value="0") 希望しない

  div(v-if="step == 2")
    div.form-group
      b-form-radio-group(v-model="question1", name="question1")
        b-form-radio.mb-4(value="self_service") 
          | 自社で運営しているWebサイトに導入
          | （貴社が、購入・予約・申込等を目的としたWebサイトを運営）
        b-form-radio.mb-4(value="other_service")
          | 他社で運営しているWebサイトに導入
        b-form-radio.mb-4(value="affiliate_site")
          | アフィリエイトサイトに導入
  
  div(v-if="question1 === 'self_service' && step == 3")
    div.form-group
      b-form-radio-group(v-model="question2", name="question2")
        b-form-radio.d-block.mb-4(value="ec") 
          | 通販
        b-form-radio.d-block.mb-4(value="non_ec") 
          | 通販以外
        b-form-radio.d-block.mb-4(value="web_media") 
          | Webメディア
  div(v-if="question1 === 'other_service' && step == 3")
    div.form-group
      label(for="question2").mb-4 他社サービスの種類を選択してください
      b-form-radio-group(v-model="question2", name="question2")
        b-form-radio.d-block.mb-4(value="agency") 
          | 広告代理店
        b-form-radio.d-block.mb-4(value="production") 
          | 制作会社
        b-form-radio.d-block.mb-4(value="consultant") 
          | コンサルティング会社
  div(v-if="question1 === 'affiliate_site' && step == 3")
    div.form-group
      label(for="question2") アフィリエイトサイトの種類を選択してください
      b-form-radio-group(v-model="question2", name="question2")
        b-form-radio.mb-2(value="aff_ad") 
          | 広告集客のアフィリエイトサイト
        b-form-radio.mb-2(value="aff_not_ad") 
          | 広告集客以外のアフィリエイトサイト

  div(v-if="step == 4")
    div(v-if="question1 === 'self_service' && question2 === 'ec'")
      div.form-group
        label(for="category") 事業内容
        b-form-select(v-model="membership_category", :options="ecCategories")

    div(v-if="question1 === 'self_service' && question2 === 'non_ec'")
      div.form-group
        label(for="category") 事業内容
        b-form-select(v-model="membership_category", :options="nonEcCategories")
    
    div(v-if="question1 === 'self_service' && question2 === 'web_media'")
      div.form-group
        label(for="category") 事業内容
        b-form-select(v-model="membership_category", :options="mediaCategories")

    div(v-if="question1 === 'other_service'")
      div.form-group
        label(for="category") 事業内容
        b-form-select(v-model="membership_category", :options="agencyCategories")

    div(v-if="question1 === 'affiliate_site'")
      div.form-group
        label(for="category") 事業内容
        b-form-select(v-model="membership_category", :options="affiliateCategories")
    
    div.form-group
      label(for="category") 従業員数
      b-form-select(v-model="employee_count", :options="employeeOptions")

  div(v-if="step == 5")
    div
      p サイトリードから適宜ご連絡をいたします。
      p （新機能や活用事例のご紹介、メンテナンスの事前告知など）
    div.chatwork-cta-wrap.text-center
      a.chatwork-cta(
        href="https://kcw.kddi.ne.jp/g/sitelead"
        target="_blank"
        rel="noopener noreferrer"
      )
        img.chatwork-cta__logo(
          src="/img/cw_logo_hz_color.svg"
          alt="Chatwork"
        )

  template(v-slot:modal-footer)
    template.text-center(v-if="step < 5")
      div.d-flex.justify-content-center.w-100
        b-button(variant="success", @click="prevStep" v-if="step > 2" class="mr-2") 戻る
        b-button(variant="success", :disabled="!validateStep1()" @click="nextStep" v-if="step === 1") 次へ
        b-button(variant="success", :disabled="!validateStep2()" @click="nextStep" v-if="step === 2") 次へ
        b-button(variant="success", :disabled="!validateStep3()" @click="nextStep" v-if="step === 3") 次へ
        b-button(variant="success", :disabled="!validateTel() || !validateHost() || !validateStep4()" @click="nextStep" v-if="step === 4") 次へ
    template.text-center(v-else)
      div.d-flex.justify-content-center.w-100
        b-button(variant="success", @click="prevStep" class="mr-2") 戻る
        b-button(variant="success", @click="submit($event)") サイトリードを始める
</template>

<script>
import Vue from "vue";

export default {
  props: {
    new_user: Boolean,
    policy_accepted_at: String,
    current_user: Object,
  },
  data() {
    return {
      step: 1,
      question1: "", // 質問1の選択
      question2: "", // 質問2の選択
      ecCategories: [
        { value: "", text: "選択してください" },
        { value: "ec_health", text: "通販（健康食品・サプリ）" },
        { value: "ec_cosmetic", text: "通販（コスメ・美容商品）" },
        { value: "ec_fashion", text: "通販（ファッション）" },
        { value: "ec_food", text: "通販（飲食品）" },
        { value: "ec_livingware", text: "通販（家電・日用品）" },
        { value: "ec_other", text: "通販（その他）" },
      ],
      nonEcCategories: [
        { value: "", text: "選択してください" },
        { value: "not_ec_esthetic", text: "エステ・サロン・ジム" },
        { value: "not_ec_clinic", text: "クリニック・病院" },
        { value: "not_ec_job", text: "人材（転職・派遣・求人）" },
        { value: "not_ec_house", text: "住宅・不動産・リフォーム" },
        { value: "not_ec_education", text: "教育・学習塾" },
        { value: "not_ec_finance", text: "金融・保険" },
        { value: "not_ec_entertainment", text: "エンターテインメント" },
        { value: "not_ec_car", text: "自動車関連" },
        { value: "not_ec_travel", text: "旅行・宿泊施設" },
        { value: "not_ec_phone", text: "通信(電話・ネット回線など)" },
        { value: "not_ec_matching", text: "婚活・恋活" },
        { value: "not_ec_profession", text: "士業（弁護士・税理士など）" },
        { value: "not_ec_btob", text: "BtoB" },
        { value: "not_ec_noprofit", text: "非営利団体（行政・学校など）" },
        { value: "not_ec_other", text: "その他" },
        // 他のカテゴリも追加
      ],
      agencyCategories: [
        { value: "", text: "選択してください" },
        { value: "ag_ad_agency", text: "広告代理店" },
        { value: "ag_cr_agency", text: "制作会社" },
        { value: "ag_consultant", text: "コンサルティング会社" },
      ],
      affiliateCategories: [
        { value: "", text: "選択してください" },
        { value: "aff_ad", text: "広告集客のアフィリエイトサイト" },
        { value: "aff_not_ad", text: "広告集客以外のアフィリエイトサイト" },
      ],
      mediaCategories: [
        { value: "", text: "選択してください" },
        { value: "m_media", text: "Webメディア" },
      ],
      employeeOptions: [
        { value: "", text: "選択してください" },
        { value: '1名', text: '1名' },
        { value: '2～5名', text: '2～5名' },
        { value: '5～10名', text: '5～10名' },
        { value: '11名～30名', text: '11名～30名' },
        { value: '31名～100名', text: '31名～100名' },
        { value: '101名～300名', text: '101名～300名' },
        { value: '301名～500名', text: '301名～500名' },
        { value: '500名～1000名', text: '500名～1000名' },
        { value: '1001名以上', text: '1001名以上' },
      ],
      label: "",
      // 送信データ
      company_name: this.current_user?.company_name || "",
      name: this.current_user?.name || "",
      tel: this.current_user?.tel || "",
      host: this.current_user?.host || "",
      membership_type: this.current_user?.membership_type || "",
      membership_category: this.current_user?.membership_category || "",
      employee_count: this.current_user?.employee_count || "",
      is_support_required: 0,
    };
  },
  computed : {
    // ステップごとにmodal_title を設定
    modal_title() {
      if (this.step == 1) {
        return "アカウント情報を入力してください。";
      } else if (this.step == 2) {
        return "サイトリードを導入するWebサイトを選択してください。";
      } else if (this.step == 3 || this.step == 4) { 
        return "事業内容を選択してください。";
      } else {
        return "「サイトリードのお知らせ」グループへ参加してください。";
      }
    }
  },
  methods: {
    // Step 1 のバリデーション
    validateStep1() {
      return (
        this.company_name !== "" &&
        this.name !== "" &&
        this.tel !== "" &&
        this.validateTel() &&
        this.host !== "" &&
        this.is_support_required !== null &&
        this.validateHost()
      );
    },
    // Step 2 のバリデーション
    validateStep2() {
      return this.question1 !== "";
    },
    // Step 3 のバリデーション
    validateStep3() {
      return this.question2 !== "";
    },
    // Step 4 のバリデーション
    validateStep4() {
      return (
        this.membership_category !== "" &&
        this.employee_count !== ""
      );
    },
    nextStep() {
      console.log('sssss');
      
      // 質問1の回答によって次のステップを変更
      if (this.step != 4 && this.question1 == 'affiliate_site') {
        this.step = 4
      } else {
        this.step++;
      }
    },
    prevStep() {
      if (this.step == 4) this.membership_category = "";
      if (this.step == 3) this.question2 = "";
      if (this.step != 5 && this.question1 == 'affiliate_site') {
        this.step = 2
      } else {
        this.step--;
      }
    },
    validateHost() {
      const urlRegex =
        /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]+)*(\/[\w-]+\.[\w-]+)*(\/?)(\?.*)?$/;
      return (
        urlRegex.test(this.host) ||
        this.host.startsWith("http://") ||
        this.host.startsWith("https://")
      );
    },
    validateTel() {
      if (this.current_user?.tel) {
        return true;
      }
      const telRegex = /^\d+$/;
      return telRegex.test(this.tel);
    },
    async submit(e) {
      e.preventDefault();
      // 顧客属性を設定
      if (this.question1 === "other_service") {
        this.membership_type = 3; // agency
      } else if (this.question1 === "affiliate_site") {
        this.membership_type = 4; // affiliate
      } else {
        if (this.question2 === "ec") {
          this.membership_type = 1; // ec_advertiser
        } else if (this.question2 === "non_ec") {
          this.membership_type = 2; // advertiser
        } else {
          this.membership_type = 5; // media
        }
      }
      // ディレクトリは削除して登録
      let fullUrl = this.host;
      if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
        fullUrl = 'https://' + fullUrl;
      }
      const urlObject = new URL(fullUrl);
      const host = `${urlObject.protocol}//${urlObject.hostname}`;
      await this.$store.dispatch("user/saveUserInfo", {
        tel: this.tel,
        host: host,
        company_name: this.company_name,
        name: this.name,
        membership_type: this.membership_type,
        membership_category: this.membership_category,
        employee_count: this.employee_count,
        is_support_required: this.is_support_required || 0,
        label: this.label,
      });
      window.location.href = "/users/tag_domains";
      this.$bvModal.hide("modal-user_info_add");
    },
  },
  components: {},
  async mounted() {
    await Vue.nextTick();
    this.$bvModal.show("modal-user_info_add");
    if (this.company_name != null && this.company_name != "" && this.name != null && this.name != "" && this.tel != null && this.tel != "" && this.host != null && this.host != "") {
      this.step = 2;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  justify-content: center;
}
.btn-auth-login {
  background-color: #ffffff;
  border-radius: 20px;
}
.icon-google {
  background-color: #ffffff;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 30px;
  height: 30px;
}
.chatwork-cta-wrap {
  margin: 1.25rem 0;
}
.chatwork-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  padding: 10px 16px;
  border: 1px solid #ced4da;
  border-radius: 0;
  background-color: #ffffff;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover,
  &:focus {
    background-color: #f8f9fa;
    border-color: #adb5bd;
    text-decoration: none;
  }
}
.chatwork-cta__logo {
  display: block;
  height: 32px;
  width: auto;
}
</style>

<style lang="scss">
@media (min-width: 992px) {
  .modal-user-info-add--step5.modal-lg {
    max-width: 580px;
  }
}
</style>
